module.exports = __webpack_public_path__ + "static/media/money-transfer.5f39ad29.svg";